(function (window, $, undefined) {
    window.JVZoo = window.JVZoo || {};
    window.JVZoo.FieldMessages = window.JVZoo.FieldMessages || {};
    window.JVZoo.FieldMessages.MessageType = window.JVZoo.FieldMessages.MessageType || {
        INFO: 'info',
        SUCCESS: 'success',
        WARNING: 'warning',
        ERROR: 'error'
    };

    var _getMessageElementAttributesByMessageType = function (messageType) {
        switch (messageType) {
            case window.JVZoo.FieldMessages.MessageType.INFO:
                return { class: 'alert alert-info' }
            case window.JVZoo.FieldMessages.MessageType.SUCCESS:
                return { class: 'alert alert-success' }
            case window.JVZoo.FieldMessages.MessageType.WARNING:
                return { class: 'alert alert-warning' }
            case window.JVZoo.FieldMessages.MessageType.ERROR:
                return { class: 'alert alert-danger' }
            default:
                return { class: null, style: null}
        }
    }
    var _selectors = {
        allFormErrors: '.formerror',
    };

    var _showSpeed = 1000;
    var _hideSpeed = _showSpeed/2;

    var DATA_FIELD_MESSAGE_FOR_ATTRIBUTE_NAME = 'data-field-message-for'

    window.JVZoo.FieldMessages.Hide = function () {
        var $formErrorElements = $(_selectors.allFormErrors);
        if (!$formErrorElements.length) {
            return;
        }
        $formErrorElements.each(function (index, element) {
            $(element).fadeOut(_hideSpeed, function () {
                $(element).text(null);
            });
        });
    };

    window.JVZoo.FieldMessages.ClearMessagesForParentElement =  function (parentElementSelector) {
        return _removeAllMessagesForParentElement(
            'window.JVZoo.FieldMessages.ClearMessagesForParentElement',
            parentElementSelector
        )
    }
    window.JVZoo.FieldMessages.RemoveMessageForParentElementByMessageName = function (parentElementSelector, messageElementName) {
        return _removeMessageForParentElementByMessageElementName(
            'window.JVZoo.FieldMessages.RemoveErrorForElement',
            parentElementSelector,
            messageElementName
        );
    }

    window.JVZoo.FieldMessages.AddInfoForElement = function (parentElementSelector, messageElementName, message) {
        return _AddMessageForElement(
            'window.JVZoo.FieldMessages.AddInfoForElement',
            window.JVZoo.FieldMessages.MessageType.INFO,
            parentElementSelector,
            messageElementName,
            message
        )
    }

    window.JVZoo.FieldMessages.AddSuccessForElement = function (parentElementSelector, messageElementName, message) {
        return _AddMessageForElement(
            'window.JVZoo.FieldMessages.AddSuccessForElement',
            window.JVZoo.FieldMessages.MessageType.SUCCESS,
            parentElementSelector,
            messageElementName,
            message
        )
    }

    window.JVZoo.FieldMessages.AddWarningForElement = function (parentElementSelector, messageElementName, message) {
        return _AddMessageForElement(
            'window.JVZoo.FieldMessages.AddWarningForElement',
            window.JVZoo.FieldMessages.MessageType.WARNING,
            parentElementSelector,
            messageElementName,
            message
        )
    }

    window.JVZoo.FieldMessages.AddErrorForElement = function (parentElementSelector, messageElementName, message) {
        return _AddMessageForElement(
            'window.JVZoo.FieldMessages.AddErrorForElement',
            window.JVZoo.FieldMessages.MessageType.ERROR,
            parentElementSelector,
            messageElementName,
            message
        )
    }

    var _removeAllMessagesForParentElement = function (caller, parentElementSelector) {
        var validationResult = _validateFieldMessageParameters(
            false,
            false,
            parentElementSelector,
            null
        );
        if (true !== validationResult.isValid) {
            validationResult.parameterErrorArgs.unshift(caller+' failed.');
            console.error.apply(console, validationResult.parameterErrorArgs)
            return false;
        }

        $(validationResult.allMessageElementsSelector).each(function () { _removeElement($(this)); })
        // _removeElement(response.$parentElement)
    };

    var _removeMessageForParentElementByMessageElementName = function (caller, parentElementSelector, messageElementName) {
        var validationResult = _validateFieldMessageParameters(
            false,
            true,
            parentElementSelector,
            messageElementName
        );
        if (true !== validationResult.isValid) {
            validationResult.parameterErrorArgs.unshift(caller+' failed.');
            console.error.apply(console, validationResult.parameterErrorArgs)
            return false;
        }

        $(validationResult.messageNameElementSelector).each(function () { _removeElement($(this)); })
        // _removeElement(response.$parentElement)
    };

    _AddMessageForElement = function (caller, messageType, parentElementSelector, messageElementName, message) {
        var validationResult = _validateFieldMessageParameters(
            true,
            true,
            parentElementSelector,
            messageElementName,
            message
        );
        if (true !== validationResult.isValid) {
            validationResult.parameterErrorArgs.unshift('window.JVZoo.FieldMessages.ShowErrorForElement failed.');
            console.error.apply(console, validationResult.parameterErrorArgs)
            return false;
        }

        /*
         * Create the Message element to be displayed
         */
        var messageElementAttributes = _getMessageElementAttributesByMessageType(messageType);

        var $newMessageElement = $('<div></div>')
            .attr('class', messageElementAttributes.class)
            // .attr('style', 'display: none')
            .attr('name', messageElementName)
            .attr(DATA_FIELD_MESSAGE_FOR_ATTRIBUTE_NAME, validationResult.parentElementId)
            // as per https://getbootstrap.com/docs/4.0/components/alerts/
            .attr('role', 'alert')
            .html(message)
            .hide()
        ;

        /*
         * Check to see if this message already exists
         */
        var $messageElement = $(validationResult.messageNameElementSelector);
        if ($messageElement.length > 0) {
            // if any matched, then fade the element(s) out before removing them and fading in the new element
            $messageElement.each(function () {
                _removeElement($(this));
            })
        }
        // append it as hidden, then reveal it using _showSpeed
        validationResult.$parentElement.after($newMessageElement);
        $newMessageElement.fadeIn(_showSpeed)
        return true;
    };

    var _removeElement = function ($element) {
        if ($element instanceof $ && $element.length > 0) {
            $element.fadeOut(_hideSpeed, function () {
                $element.remove();
            });
        }
    }

    var _validateFieldMessageParameters = function (isMessageRequired, isMessageNameRequired, parentElementSelector, messageElementName, message) {
        var response = {
            parentElementId: null,
            $parentElement: null,
            messageNameElementSelector: null,
            allMessageElementsSelector: null,
            isValid: false,
            parameterErrorArgs: [],
        };
        /*
         * ensure the element has either been provided or can be identified using the parentElementSelector
         */
        var $parentElement = parentElementSelector instanceof $ ? parentElementSelector : $(parentElementSelector);
        if ($parentElement.length < 1) {
            response.parameterErrorArgs = [
                "\nUnable to locate parent element for the field message.",
                "\nparentElementSelector: ",
                parentElementSelector,
                "\nmessageElementName: ",
                messageElementName,
                "\nmessage: ",
                message
            ];
            return response;
        }
        response.$parentElement = $parentElement;

        /*
         * ensure that the element for which the message wil be created has an id attribute and value
         */
        var parentElementId = $parentElement.attr('id');
        if (!parentElementId) {
            response.parameterErrorArgs = [
                "\nThe parent element for the field message does not contain an 'id' attribute.",
                "\nparentElementSelector: ",
                parentElementSelector,
                "\nmessageElementName: ",
                messageElementName,
                "\nmessage: ",
                message
            ];
            return response;
        }
        response.parentElementId = parentElementId;

        /*
         * ensure that field messages can also be removed by calling window.JVZoo.FieldMessages.RemoveFieldMessage
         * and providing the same fieldElementSelector and messageElementName
         */
        if (true === isMessageNameRequired) {
            if (!messageElementName || (typeof messageElementName) !== "string") {
                response.parameterErrorArgs = [
                    "\nThe messageElementName parameter must be string that identifies the field message element to be displayed or removed.",
                    "\nparentElementSelector: ",
                    parentElementSelector,
                    "\nmessageElementName: ",
                    messageElementName,
                    "\nmessage: ",
                    message
                ];
                return response;
            }
            response.messageNameElementSelector = 'div['+DATA_FIELD_MESSAGE_FOR_ATTRIBUTE_NAME+'="'+parentElementId+'"][name="'+messageElementName+'"]';
        }

        /*
         * If the caller specified that a message must be provided, validate it now
         */
        if (true === isMessageRequired && (!message || (typeof message) !== "string")) {
            response.parameterErrorArgs = [
                "\nThe message parameter is not a string.",
                "\nparentElementSelector: ",
                parentElementSelector,
                "\nmessageElementName: ",
                messageElementName,
                "\nmessage: ",
                message
            ];
            return response;
        }
        /*
         * build the field messages selector
         */
        response.allMessageElementsSelector = 'div['+DATA_FIELD_MESSAGE_FOR_ATTRIBUTE_NAME+'="'+parentElementId+'"]';
        response.isValid = true;
        return response;
    }
})
(window, jQuery);